require("../../static/jquery.min.js");
require("../../static/jquery.qrcode.min.js");
export default {
    
    getStaticUrl () {
        return 'http://192.168.1.10:8686'
    },
    randomString (len) {
        len = len || 16;
        let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        let maxPos = $chars.length;
        let pwd = '';
        for (let i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    },
    // 清除二维码
    clearqrCode (DOMid = 'body') {
        setTimeout(() => {
            document.querySelector(DOMid).innerHTML = '';
        }, 300)
    },
    // 生成二维码
    newQrcode (DOMid = 'body', text = 'text', width = 20, height = 20) {
        var urlPro = '';
        if (text.includes('yypd.66yunlian.cn')) {
            urlPro = text.replace('yypd.66yunlian.cn', window.location.host + '/h5');
        } else {
            urlPro = text;
        }
        if (urlPro.includes("https:")) {
            urlPro = urlPro.replace('https:', window.location.protocol);
        } else if (urlPro.includes('http:')) {
            urlPro = urlPro.replace('http:', window.location.protocol);
        };
        console.log(urlPro)
        var id = '#' + DOMid;
        document.querySelector(id).innerHTML = '';
        $(id).qrcode({
            render: 'canvas',
            width: width,
            height: height,
            correctLevel: 0,
            text: urlPro
        })
    },
}



// WEBPACK FOOTER //
// ./src/utils/index.js